import React, { Component } from "react";
import BootstrapTable from "react-bootstrap-table-next";
// 
import Modal from "react-responsive-modal";
import {
  Button,
  Form,
  FormGroup,
  Label,
  Col
} from "reactstrap";
import SweetAlert from "react-bootstrap-sweetalert";

import { Link, Redirect } from "react-router-dom";

// koneksi
import API_URL, { Post, Get, Delete, JENIS_DUSUN } from "../function/Koneksi";

// Preview Surat
import Iframe from 'react-iframe'

// css files
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import ModalSuratTidakMampu from "./modal/tidak-mampu";


const formOrangTua = {
  nik: "",
  nama: "",
  tempat_lahir: "",
  tanggal_lahir: "",
  alamat: "",
};

const frmDex = {
  uuid: '',
  id_jenis: '',
  nik_pelapor: '',
  nik: '',
  kk: '',
  nama_pemohon: '',
  tempat_lahir: '',
  tanggal_lahir: '',
  jenis_kelamin: '',
  pekerjaan: '',
  pendidikan_terakhir: '',
  kewarganegaraan: '',
  agama: '',
  alamat: '',
  status_perkawinan: '',
  tujuan_pembuatan: '',
  keterangan_tambahan: '',
  detail: [],
  orang_tua_wali:formOrangTua,
}

let detail = [];
let aw = {
  nama: "",
  nik: "",
  tempat_lahir: "",
  tanggal_lahir: "",
  jenis_kelamin: "",
  pekerjaan: "",
};

class BasicTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      pagination: [],
      status: {
        form: false,
        btnForm: false,
        btnAksi: [],
        dataPenduduk: "none",
        dataPenduduk2: "none",
        dataAnggotaKeluarga: "none",
        dataOrangTua: "none",
        frmDataOrangTua: "none",
        frmDetailDataOrangTua: "none",
        frmKeteranganTambahan: "none",
        frmPreviewDraft: false,
        jenis_form: '',
      },
      awal: "",
      sebelum: "",
      hal: [],
      setelah: "",
      akhir: "",
      dt: frmDex,
      loading: false,
      loadingPreview: false,
      tmplistPenduduk: null,
      tmplistPenduduk3: null,
      judul: "Tambah Surat Keterangan Tidak Mampu",
      shdk: "",
      detail: [],
      shdk_aw: null,
      // ============ Select 2 ==============
      frmJam: [],
      jamStat: [],
      frmPkr: [],
      pkrStat: [],
      frmAgm: [],
      frmShdk: null,
      agmStat: [],
      frmNik: [],
      nikStat: null,
      frmNik2: [],
      nik2Stat: null,
      frmNik3: [],
      nik3Stat: null,
      formOpsional: [
        { value: 'tanpa_opsi', label: 'Tidak Ada Data Opsional'},
        { value: 'orangtua_wali', label: 'Tambahkan Data Orang Tua/Wali'},
        { value: 'anggota_keluarga', label: 'Tambahkan Data Anggota Keluarga'},
        // { value: 'keterangan_lainnya', label: 'Tambahkan Keterangan Lainnya'},
      ],
      opsionalStat: 'tanpa_opsi',
      // ===================================
      // ============ Alert ==============
      alert: null,
      show: false,
      basicTitle: "",
      basicType: "default",
      pesanAlert: "",
      successAlert: false,

      // ===================================
      // ============ Tanggal ==============
      tanggal_surat: new Date(),
      tanggal_lahir: new Date(),
      waktu_meninggal: new Date(),
      waktu_meninggal2: new Date(),
      // ===================================
      // =============== acc ===============
      formAcc: false,
      formSelectAcc: [
        { value: "Disetujui", label: "Disetujui" },
        { value: "Ditolak", label: "Ditolak" }
      ],
      frmTTD: [],
      accButton: [],
      accuuid: "",
      btnFormAcc: true,
      tableAcc: "none",
      //list disposisi
      datDisposisi: [],
      riwayatDisposisi: [],

      // Preview surat
			get_data_surat:[],
			get_jenis_surat: "",

      // Cari Data
      dataCari: {
				q: '',
			},
    };
  }
  // ================== Terbilang ===================

  terbilang = a => {
    // pastikan kita hanya berususan dengan tipe data numeric
    let angka = parseFloat(a);
    let hasil_bagi = 0;
    let hasil_mod = 0;
    // array bilangan
    // sepuluh dan sebelas merupakan special karena awalan 'se'
    const bilangan = [
      "",
      "satu",
      "dua",
      "tiga",
      "empat",
      "lima",
      "enam",
      "tujuh",
      "delapan",
      "sembilan",
      "sepuluh",
      "sebelas"
    ];
    if (angka ===  1) {
      return "setahun";
    }
    // pencocokan dimulai dari satuan angka terkecil
    else if (angka < 12) {
      // mapping angka ke index array bilangan
      return bilangan[angka] + " tahun";
    } else if (angka < 20) {
      // bilangan 'belasan'
      // misal 18 maka 18 - 10 = 8
      return bilangan[angka - 10] + " belas tahun";
    } else if (angka < 100) {
      // bilangan 'puluhan'
      // misal 27 maka 27 / 10 = 2.7 (integer => 2) 'Dua'
      // untuk mendapatkan sisa bagi gunakan modulus
      // 27 mod 10 = 7 'Tujuh'
      hasil_bagi = parseInt(angka / 10);
      hasil_mod = angka % 10;
      return bilangan[hasil_bagi] + " puluh " + bilangan[hasil_mod] + " tahun";
    } else if (angka < 200) {
      // bilangan 'seratusan' (itulah indonesia knp tidak satu ratus saja? :))
      // misal 151 maka 151 = 100 = 51 (hasil berupa 'puluhan')
      // daripada menulis ulang rutin kode puluhan maka gunakan
      // saja fungsi rekursif dengan memanggil fungsi terbilang(51)
      return "Seratus " + this.terbilang(angka - 100);
    } else if (angka < 1000) {
      // bilangan 'ratusan'
      // misal 467 maka 467 / 100 = 4,67 (integer => 4) 'Empat'
      // sisanya 467 mod 100 = 67 (berupa puluhan jadi gunakan rekursif terbilang(67))
      hasil_bagi = parseInt(angka / 100);
      hasil_mod = angka % 100;
      return (
        bilangan[hasil_bagi] + " Ratus " + this.terbilang(hasil_mod) + " tahun"
      );
    } else if (angka < 2000) {
      // bilangan 'seribuan'
      // misal 1250 maka 1250 - 1000 = 250 (ratusan)
      // gunakan rekursif terbilang(250)
      return "Seribu " + this.terbilang(angka - 100);
    } else if (angka < 1000000) {
      // bilangan 'ribuan' (sampai ratusan ribu
      hasil_bagi = parseInt(angka / 1000); // karena hasilnya bisa ratusan jadi langsung digunakan rekursif
      hasil_mod = angka % 1000;
      return (
        this.terbilang(hasil_bagi) +
        " Ribu " +
        this.terbilang(hasil_mod) +
        " tahun"
      );
    } else if (angka < 1000000000) {
      // bilangan 'jutaan' (sampai ratusan juta)
      // 'satu puluh' => SALAH
      // 'satu ratus' => SALAH
      // 'satu juta' => BENAR
      // @#$%^ WT*

      // hasil bagi bisa satuan, belasan, ratusan jadi langsung kita gunakan rekursif
      hasil_bagi = parseInt(angka / 1000000);
      hasil_mod = angka % 1000000;
      return (
        this.terbilang(hasil_bagi) +
        " Juta " +
        this.terbilang(hasil_mod) +
        " tahun"
      );
    } else if (angka < 1000000000000) {
      // bilangan 'milyaran'
      hasil_bagi = parseInt(angka / 1000000000);
      // karena batas maksimum integer untuk 32bit sistem adalah 2147483647
      // maka kita gunakan fmod agar dapat menghandle angka yang lebih besar
      hasil_mod = angka % 1000000000;
      return (
        this.terbilang(hasil_bagi) +
        " Milyar " +
        this.terbilang(hasil_mod) +
        " tahun"
      );
    } else if (angka < 1000000000000000) {
      // bilangan 'triliun'
      hasil_bagi = angka / 1000000000000;
      hasil_mod = angka % 1000000000000;
      return (
        this.terbilang(hasil_bagi) +
        " Triliun " +
        this.terbilang(hasil_mod) +
        " tahun"
      );
    } else {
      return "Wow...";
    }
  };
  // ===============================================

  // ================== Tanggal ===================

  gantiTgl = (date, fld) => {
    switch (fld) {
      case "tanggal_surat":
        this.setState({ tanggal_surat: date });
        break;
      case "waktu_meninggal":
        this.setState({ waktu_meninggal: date });
        break;
      case "waktu_meninggal2":
        this.setState({ waktu_meninggal2: date });
        break;
      default:
        // no default
        break;
      // case 'tanggal_lahir': this.setState({tanggal_lahir:date});break;
    }
  };

  // ==============================================

  // ================== Sweet Alert ==================
  closeAlert = () => {
    this.setState({
      show: false,
      successAlert: false
    });
  };

  onRecieveInput = value => {
    this.setState({
      alert: (
        <SweetAlert success title="Nice!" onConfirm={this.hideAlert}>
          You wrote: {value}
        </SweetAlert>
      )
    });
  };

  hideAlert = () => {
    this.setState({
      alert: null
    });
  };

  // =================================================

  // ================== Ambil data dari db untuk table ==================
  fetch = (params = {}) => {
    this.setState({ loading: true })
    let link = "";
    // let where = [];
    // if (params.where) {
    //   where = params.where;
    // }
    if (params.page) {
      switch (params.page) {
        case ">>":
          link =
            "?page=" +
            Math.ceil(
              this.state.pagination.total / this.state.pagination.per_page
            );
          break;
        case ">":
          link = "?page=" + (parseInt(this.state.pagination.current_page) + 1);
          break;
        case "<":
          link = "?page=" + (parseInt(this.state.pagination.current_page) - 1);
          break;
        case "<<":
          link = "?page=1";
          break;
        default:
          link = "?page=" + params.page;
          break;
      }
    }
    Post(
      "surat-keterangan/grup/" + this.props.location.state.uuid + link,
      null, this.state.dataCari,
      dtkat => {
        if(dtkat.data.results){
          this.setState({ data: dtkat.data.results.data, pagination: dtkat.data.results, loading: false });
          this.pagination(dtkat.data.results); 
          
           // For testing
           if (this.props.getListSuratKeteranganTidakMampu) {
            this.props.getListSuratKeteranganTidakMampu(dtkat.data.results.data)
          }
        }
      }
    );
  };

  // Pagination
  pagination = data => {
    // const data = this.state.pagination;
    // //console.log(data);
    let awal = "";
    let hal = [];
    let sebelum = "";
    let setelah = "";
    let akhir = "";
    if (data.total > 0) {
      let start = 1;
      let end = 5;
      let n = 0;
      let p = 0;
      if (data.current_page <= 3) {
        start = 1;
        end = 5;
        if (data.last_page > data.current_page) {
          n = data.current_page + 1;
        }
      } else {
        p = data.current_page - 1;
        n = data.current_page + 1;
        start = data.current_page - 2;
        end = data.current_page + 2;
      }
      if (end >= data.last_page - 2) {
        p = data.current_page - 1;
        if (start >= 5) {
          start = data.last_page - 4;
        }
        end = data.last_page;
      }

      for (let i = start; i <= end; i++) {
        let warna = "primary-custom";
        if (i ===  data.current_page) {
          warna = "danger";
        }
        hal.push(
          <a
            href={() => false}
            onClick={() => this.fetch({ page: i })}
            className={
              "btn btn-" + warna + " btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
            }
          >
            {i}
          </a>
        );
      }
      if (p > 0) {
        sebelum = (
          <a
            href={() => false}
            onClick={() => this.fetch({ page: p })}
            className="btn btn-primary-custom btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
          >
            {"<"}
          </a>
        );
      }
      if (n > 0) {
        setelah = (
          <a
            href={() => false}
            onClick={() => this.fetch({ page: n })}
            className="btn btn-primary-custom btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
          >
            {">"}
          </a>
        );
      }
      awal = (
        <a
          href={() => false}
          onClick={() => this.fetch({ page: 1 })}
          className="btn btn-primary-custom btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
        >
          {"<<"}
        </a>
      );
      akhir = (
        <a
          href={() => false}
          onClick={() => this.fetch({ page: data.last_page })}
          className="btn btn-primary-custom btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
        >
          {">>"}
        </a>
      );
    }
    this.setState({ awal, sebelum, hal, setelah, akhir });
  };
  
  
  // CARI DATA SURAT
  cariData = e => {
    if (e.key === 'Enter') {
      this.setState({ 
        dataCari:{
          ...this.state.dataCari,
          q: e.target.value,
        }, 
      });

      setTimeout(
        function() {
          this.fetch({ page: null, where: [] });
        }.bind(this),
        500
      );
    }
  };

  // ========================================================================

  // ================== simpan data ==================
  simpan = e => {
    e.preventDefault();
    if (this.state.nikStat) {
      this.setState({
        status:{
          ...this.state.status,
          btnForm: true,
        },
      })
      this.forceUpdate();
      let tgl_lhr = this.state.dt.tanggal_lahir.split("/");
      let tanggal_lahir = tgl_lhr[2] + "-" + tgl_lhr[1] + "-" + tgl_lhr[0];
      let addSuratKeteranganTidakMampu = {
        uuid: document.getElementById("uuid").value,
        id_jenis: this.props.location.state.uuid,
        // nomor : document.getElementById("nomor").value,

        nik_pelapor: this.state.nikStat.value,
        nik: this.state.nikStat.value,
        kk: this.state.dt.kk,
        nama_pemohon: this.state.dt.nama,
        tempat_lahir: this.state.dt.tempat_lahir,
        tanggal_lahir: tanggal_lahir,
        jenis_kelamin: this.state.dt.jenis_kelamin,
        pekerjaan: this.state.dt.pekerjaan,
        pendidikan_terakhir: this.state.dt.pendidikan_terakhir,
        kewarganegaraan: this.state.dt.kewarganegaraan,
        agama: this.state.dt.agama,
        alamat: this.state.dt.alamat,
        status_perkawinan: this.state.dt.status_perkawinan,
        tujuan_pembuatan : document.getElementById("tujuan_pembuatan").value,
        detail: this.state.detail
      };
      
      //console.log("Data Simpan Tidak Mampu")
      //console.log(addSuratKeteranganTidakMampu)

      let psn = "";
      let resstat = 204;
      let metode = "create";
      if (addSuratKeteranganTidakMampu.uuid === "") {
        psn = "Tambah";
        resstat = 201;
        addSuratKeteranganTidakMampu.uuid = null;
      } else {
        psn = "Ubah";
        resstat = 200;
        metode = "update";
      }
      Post(
        "surat-keterangan/tidak-mampu/" + metode,
        addSuratKeteranganTidakMampu.uuid,
        addSuratKeteranganTidakMampu,
        res => {
          // For testing
          if (this.props.resSubmit) {
            this.props.resSubmit(res.status)
          }
          this.tutupForm();
          this.setState({
            status:{
              ...this.state.status,
              btnForm: false,
              form: false,
            },
          })
          this.forceUpdate();
          if (res.status === resstat) {
            this.setState({
              show: true,
              basicType: "success",
              basicTitle: "Data Surat KeteranganTidak Mampu",
              pesanAlert: "Berhasil " + psn + " Data",
              successAlert: true
            });
          } else {
            this.setState({
              show: true,
              basicType: "danger",
              basicTitle: "Data Surat KeteranganTidak Mampu",
              pesanAlert: "Gagal " + psn + " Data"
            });
          }
          this.componentDidMount();
        }
      );
    } else {
      this.setState({
        show: true,
        basicType: "warning",
        basicTitle: "Data Belum Lengkap",
        pesanAlert: "Mohon pilih data NIK Pembuat"
      });
    }
  };
  // ========================================================================
  // list disposisi

  listDisposisi = data => {
    //console.log(data);
    Get("alur-disposisi/" + data.id_jenis, null, dtkat => {
      //console.log(dtkat);
      if (dtkat) {
        //console.log(dtkat.results);

        this.setState({
          idSurat: data.uuid,
          datDisposisi: dtkat.results,
          formDisposisi: true,
          riwayatDisposisi: data.data_status_disposisi
        });
      }
    });
  };

  //disposisi
  disposisi = (label, id) => {
    //console.log(label);
    Get("disposisi/tidak-mampu/" + label + "/" + id, null, dtkat => {
      if (dtkat.code === 201) {
        this.setState({
          show: true,
          basicType: "success",
          basicTitle: "Data Disposisi",
          pesanAlert: "Berhasil  Disposisi Data"
        });
        this.componentDidMount();
        this.tutupForm();
      } else {
        this.setState({
          show: true,
          basicType: "danger",
          basicTitle: "Data Disposisi",
          pesanAlert: "Disposisi telah dilakukan"
        });
        this.tutupForm();
      }
    });
    //console.log(id);
  };

  // ============================== Ubah Data ===============================

  ubahData = id => {
    this.setState({ loadingPreview: true })

    Get("surat-keterangan/tidak-mampu/find", id, data => {
      if (data.results) {
        let detail_surat = data.results.detail_surat?JSON.parse(data.results.detail_surat):null

        if (id && data.results.kk !== '') {
          Get("penduduk/kk/"+data.results.kk, null, dtkk => {
            let frmNik3 = [];
            let tmplistPenduduk3 = {}
            dtkk.results.forEach(val => {
              frmNik3.push({ value: val.id, label: val.id + ' (' + val.nama + ')' });
              tmplistPenduduk3 = {
                ...tmplistPenduduk3,
                [val.id]: val
              }
            });

            if(detail_surat){
              // Opsi Orang Tua/Wali
              if(detail_surat.orang_tua_wali){
                Get("penduduk/find", detail_surat.orang_tua_wali.nik, dtPdd => {
                  
                  if (dtPdd.results === null) {
                    let orang_tua_wali = detail_surat.orang_tua_wali;

                    orang_tua_wali.tanggal_lahir = new Date(detail_surat.orang_tua_wali.tanggal_lahir);

                    this.setState({
                      status:{
                        ...this.state.status,
                        dataOrangTua: "",
                        frmDataOrangTua: "block",
                        frmDetailDataOrangTua: "block",
                        dataPenduduk: "block",
                        form: true,
                        dataAnggotaKeluarga: "none",
                        frmKeteranganTambahan: "none",
                      },
                      nik2Stat: null,
                      dt:{
                        ...this.state.dt,
                        uuid: data.results.uuid,
                        id_jenis: data.results.id_jenis,
                        nik: data.results.nik,
                        kk: data.results.kk,
                        nama_pemohon: data.results.nama_pemohon,
                        tempat_lahir: data.results.tempat_lahir,
                        tanggal_lahir: data.results.tanggal_lahir,
                        pekerjaan: data.results.pekerjaan,
                        pendidikan_terakhir: data.results.pendidikan_terakhir,
                        agama: data.results.agama,
                        status_perkawinan: data.results.status_perkawinan,
                        jenis_kelamin: data.results.jenis_kelamin,
                        alamat: data.results.alamat,
                        alamat_kk: data.results.alamat_kk,
                        kewarganegaraan: data.results.kewarganegaraan,
                        tujuan_pembuatan: data.results.tujuan_pembuatan,
                        nik_pelapor: data.results.nik_pelapor,
                        // tujuan_pembuatan: data.results.tujuan_pembuatan,
                        orang_tua_wali:detail_surat.orang_tua_wali,
                      },
                      nikStat: {
                        value: data.results.nik,
                        label: data.results.nik + ' (' + data.results.nama_pemohon + ')'
                      },
                      opsionalStat:'orangtua_wali',
                      frmNik3,
                      tmplistPenduduk3,
                      loadingPreview: false,
                    })
                  } else {
                    this.setState({
                      status:{
                        ...this.state.status,
                        dataOrangTua: "none",
                        frmDataOrangTua: "block",
                        frmDetailDataOrangTua: "block",
                        dataPenduduk: "block",
                        form: true,

                        dataAnggotaKeluarga: "none",
                        frmKeteranganTambahan: "none",
                      },
                      nik2Stat: {
                        value: detail_surat.orang_tua_wali.nik,
                        label: detail_surat.orang_tua_wali.nik + ' (' + detail_surat.orang_tua_wali.nama + ')'
                      },
                      dt:{
                        ...this.state.dt,
                        uuid: data.results.uuid,
                        id_jenis: data.results.id_jenis,
                        nik: data.results.nik,
                        kk: data.results.kk,
                        nama_pemohon: data.results.nama_pemohon,
                        tempat_lahir: data.results.tempat_lahir,
                        tanggal_lahir: data.results.tanggal_lahir,
                        pekerjaan: data.results.pekerjaan,
                        pendidikan_terakhir: data.results.pendidikan_terakhir,
                        agama: data.results.agama,
                        status_perkawinan: data.results.status_perkawinan,
                        jenis_kelamin: data.results.jenis_kelamin,
                        alamat: data.results.alamat,
                        alamat_kk: data.results.alamat_kk,
                        kewarganegaraan: data.results.kewarganegaraan,
                        tujuan_pembuatan: data.results.tujuan_pembuatan,
                        nik_pelapor: data.results.nik_pelapor,
                        // tujuan_pembuatan: data.results.tujuan_pembuatan,
                        orang_tua_wali:detail_surat.orang_tua_wali,
                      },
                      nikStat: {
                        value: data.results.nik,
                        label: data.results.nik + ' (' + data.results.nama_pemohon + ')'
                      },
                      opsionalStat:'orangtua_wali',
                      frmNik3,
                      tmplistPenduduk3,
                      loadingPreview: false,
                    })
                  }
                })
              }
              // Opsi Keterangan Tambahan
              else if(detail_surat.keterangan_tambahan){
                
                this.setState({
                  status:{
                    ...this.state.status,
                    dataAnggotaKeluarga: "none",
                    dataPenduduk: "none",
                    form: true,
                    dataOrangTua: "none",
                    frmDataOrangTua: "none",
                    frmDetailDataOrangTua: "none",
                    frmKeteranganTambahan: "block",
                  },
                  dt:{
                    ...this.state.dt,
                    uuid: data.results.uuid,
                    id_jenis: data.results.id_jenis,
                    nik: data.results.nik,
                    kk: data.results.kk,
                    nama_pemohon: data.results.nama_pemohon,
                    tempat_lahir: data.results.tempat_lahir,
                    tanggal_lahir: data.results.tanggal_lahir,
                    pekerjaan: data.results.pekerjaan,
                    pendidikan_terakhir: data.results.pendidikan_terakhir,
                    agama: data.results.agama,
                    status_perkawinan: data.results.status_perkawinan,
                    jenis_kelamin: data.results.jenis_kelamin,
                    alamat: data.results.alamat,
                    alamat_kk: data.results.alamat_kk,
                    kewarganegaraan: data.results.kewarganegaraan,
                    tujuan_pembuatan: data.results.tujuan_pembuatan,
                    nik_pelapor: data.results.nik_pelapor,
                    // tujuan_pembuatan: data.results.tujuan_pembuatan,
                    keterangan_tambahan:detail_surat.keterangan_tambahan,
                  },
                  nikStat: {
                    value: data.results.nik,
                    label: data.results.nik + ' (' + data.results.nama_pemohon + ')'
                  },
                  opsionalStat:'keterangan_lainnya',
                  frmNik3,
                  tmplistPenduduk3,
                  loadingPreview: false
                })
              }
            }
            else{
              // Opsi Keluarga Lainnya
              if(data.results.data_detail_tidak_mampu.length>0){
                
                this.setState({
                  status:{
                    ...this.state.status,
                    dataAnggotaKeluarga: "block",
                    dataPenduduk: "block",
                    form: true,
                    dataOrangTua: "none",
                    frmDataOrangTua: "none",
                    frmDetailDataOrangTua: "none",
                    frmKeteranganTambahan: "none",
                  },
                  dt:{
                    ...this.state.dt,
                    uuid: data.results.uuid,
                    id_jenis: data.results.id_jenis,
                    nik: data.results.nik,
                    kk: data.results.kk,
                    nama_pemohon: data.results.nama_pemohon,
                    tempat_lahir: data.results.tempat_lahir,
                    tanggal_lahir: data.results.tanggal_lahir,
                    pekerjaan: data.results.pekerjaan,
                    pendidikan_terakhir: data.results.pendidikan_terakhir,
                    agama: data.results.agama,
                    status_perkawinan: data.results.status_perkawinan,
                    jenis_kelamin: data.results.jenis_kelamin,
                    alamat: data.results.alamat,
                    alamat_kk: data.results.alamat_kk,
                    kewarganegaraan: data.results.kewarganegaraan,
                    tujuan_pembuatan: data.results.tujuan_pembuatan,
                    nik_pelapor: data.results.nik_pelapor,
                    // tujuan_pembuatan: data.results.tujuan_pembuatan,
                    detail:data.results.data_detail_tidak_mampu,
                  },
                  nikStat: {
                    value: data.results.nik,
                    label: data.results.nik + ' (' + data.results.nama_pemohon + ')'
                  },
                  opsionalStat:'anggota_keluarga',
                  frmNik3,
                  tmplistPenduduk3,
                  loadingPreview: false
                })
              }
              // Tanpa Opsi
              else{
                
                this.setState({
                  status:{
                    ...this.state.status,
                    dataPenduduk: "block",
                    form: true,
                    dataOrangTua: "none",
                    frmDataOrangTua: "none",
                    frmDetailDataOrangTua: "none",
                    dataAnggotaKeluarga: "none",
                    frmKeteranganTambahan: "none",
                  },
                  dt:{
                    ...this.state.dt,
                    uuid: data.results.uuid,
                    id_jenis: data.results.id_jenis,
                    nik: data.results.nik,
                    kk: data.results.kk,
                    nama_pemohon: data.results.nama_pemohon,
                    tempat_lahir: data.results.tempat_lahir,
                    tanggal_lahir: data.results.tanggal_lahir,
                    pekerjaan: data.results.pekerjaan,
                    pendidikan_terakhir: data.results.pendidikan_terakhir,
                    agama: data.results.agama,
                    status_perkawinan: data.results.status_perkawinan,
                    jenis_kelamin: data.results.jenis_kelamin,
                    alamat: data.results.alamat,
                    alamat_kk: data.results.alamat_kk,
                    kewarganegaraan: data.results.kewarganegaraan,
                    tujuan_pembuatan: data.results.tujuan_pembuatan,
                    nik_pelapor: data.results.nik_pelapor,
                    // tujuan_pembuatan: data.results.tujuan_pembuatan,
                  },
                  nikStat: {
                    value: data.results.nik,
                    label: data.results.nik + ' (' + data.results.nama_pemohon + ')'
                  },
                  opsionalStat:'tanpa_opsi',
                  frmNik3,
                  tmplistPenduduk3,
                  loadingPreview: false
                })
              }
            }
          })
      }
      }
      else{
        this.setState({
          loadingPreview: false,
        })
      }
    });
  };
  // ========================================================================
  // ============================= Approve Data ===============================
  konfirmApprove = id => {
    this.setState({
      judul: "Persetujuan Data ",
      formAcc: true,
      btnFormAcc: true,
      idaccSurat: id
    });
  };
  // ========================================================================
  // ============================= Hapus Data ===============================
  konfirmHapus = id => {
    this.setState({
      alert: (
        <SweetAlert
          showCancel
          confirmBtnText="Hapus"
          confirmBtnBsStyle="danger"
          cancelBtnBsStyle="success"
          type="danger"
          title="Yakin ingin hapus data ?"
          onCancel={this.hideAlert}
          onConfirm={() => this.hapusData(id)}
        >
          Proses ini tidak dapat dibatalkan!
        </SweetAlert>
      )
    });
  };

  hapus = i => {
    this.state.detail.splice(i, 1);
    this.forceUpdate();
  };

  hapusData = id => {
    this.hideAlert();
    let psn = "Hapus";
    Delete("surat-keterangan/tidak-mampu/delete", id, res => {
      if (res ===  200) {
        this.setState({
          show: true,
          basicType: "success",
          basicTitle: "Data Surat KeteranganTidak Mampu",
          pesanAlert: "Berhasil " + psn + " Data"
        });
      } else {
        this.setState({
          show: true,
          basicType: "danger",
          basicTitle: "Data Surat KeteranganTidak Mampu",
          pesanAlert: "Gagal " + psn + " Data"
        });
      }
      this.componentDidMount();
    });
  };
  // ========================================================================

  tambahData = e => {
    this.setState({
      status: {
        ...this.state.status,
        dataPenduduk: "none",
        form: true,
        dataAnggotaKeluarga: "none",
        dataOrangTua: "none",
        frmDataOrangTua: "none",
        frmDetailDataOrangTua: "none",
        frmKeteranganTambahan: "none",
      },
      judul: "Tambah Surat Keterangan Tidak Mampu",
      dt: null,
      nikStat: null,
      detail: [],
    });
  };

  bukaForm = () => {
    this.setState({
      status:{
        ...this.state.status,
        form: true,
      },
    })
    this.forceUpdate();
  };

  tutupForm = () => {
    this.setState({
      dt:{
        ...this.state.dt,
        nama: "",
        tanggal_lahir: "",
        tempat_lahir: "",
        agama: "",
        pekerjaan: "",
        pendidikan_terakhir: "",
        kewarganegaraan: "",
        alamat: "",
        jenis_kelamin: "",
        status_perkawinan: "",
      },
      status:{
        ...this.state.status,
        dataPenduduk: "none",
        form: false,
      },
      nikStat: null,
      detail: [],
      shdk_aw: null,
      accStat: [],
      tableAcc: "none",
      formAcc: false,
      formDisposisi: false,
    })

    this.forceUpdate();
  };

  persetujuan = (id, jawaban) => {
    this.hideAlert();
    Get(
      "surat-keterangan/tidak-mampu/persetujuan/" + jawaban + "/" + id,
      null,
      res => {
        if (res.code === 201) {
          this.setState({
            show: true,
            basicType: "success",
            basicTitle: "Menyetujui Surat",
            pesanAlert: "Berhasil update status"
          });
        } else {
          this.setState({
            show: true,
            basicType: "warning",
            basicTitle: "Menyetujui Surat",
            pesanAlert: "Gagal update status"
          });
        }
        this.componentDidMount();
      }
    );
  };

  tombolAksi = (cell, row) => {
    // let btnApproval = false;
    // let btnCetak = false;
    let btnAksi = false;
    let status = "";
    row.data_status.forEach(dt => {
      status = dt.status;
    });
    if (status ===  "Diajukan") {
      // btnCetak = true;
      btnAksi = true;
      // btnApproval = true;
    } else {
      btnAksi = true;
      // btnApproval = true;
      if (status ===  "Ditolak") {
        // btnCetak = true;
      } else if (status ===  "Disetujui") {
        btnAksi = false;
        // btnCetak = true;
        // btnApproval = false;
      } else if ((status ===  "Menunggu Penerbitan") | (status ===  "Selesai")) {
        // btnAksi = false;
        // btnCetak = false;
        // btnApproval = false;
      } else {
        // btnCetak = true;
      }
    }
    return (
      <>
        {/* <Button
          size="xs"
          color="info"
          className="btn-icon"
          onClick={() => this.konfirmApprove(row.uuid)}
          disabled={btnApproval}
        >
          <i className="fa fa-check"></i>
        </Button>{" "}
        &nbsp;&nbsp; */}
        <Button
          size="xs"
          color="success"
          className="btn-icon"
          onClick={() => this.ubahData(row.uuid)}
          disabled={btnAksi}
        >
          <i className="fa fa-pencil"></i>
        </Button>{" "}
        {/* &nbsp;&nbsp;
        <Button
          size="xs"
          color="danger"
          className="btn-icon"
          onClick={() => this.konfirmHapus(row.uuid)}
          disabled={btnAksi}
        >
          <i className="fa fa-trash"></i>
        </Button>{" "}
        &nbsp;&nbsp;
        <Button
          size="xs"
          color="info"
          className="btn-icon"
          onClick={e => this.cetakSurat(e, row)}
          disabled={btnCetak}
        >
          <i className="fa fa-print"></i>
        </Button>{" "}
        &nbsp;&nbsp; */}
        {/* //list */}
        {/* <Button
          size="xs"
          color="info"
          className="btn-icon"
          onClick={e => this.listDisposisi(row)}
        >
          <i className="fa fa-list"></i>
        </Button> */}
      </>
    );
  };

  componentDidMount() {
    if (this.props.location.state) {
      this.fetch({ page: null, where: [] });
      let set_jenis = this.props.location.state.route_surat.substring(1);
      this.setState({
        get_jenis_surat: set_jenis,
        formOpsional: [
          { value: 'tanpa_opsi', label: 'Tidak Ada Data Opsional'},
          { value: 'orangtua_wali', label: 'Tambahkan Data Orang Tua/Wali'},
          { value: 'anggota_keluarga', label: 'Tambahkan Data Anggota Keluarga'},
          // { value: 'keterangan_lainnya', label: 'Tambahkan Keterangan Lainnya'},
        ],
      })
      let frmJam = [];
      let jamnya = "";
      for (let i = 1; i <= 24; i++) {
        jamnya = i;
        if (i < 10) {
          jamnya = "0" + i;
        }
        jamnya += ":00";
        frmJam.push({ value: jamnya, label: jamnya });
      }
      this.setState({ frmJam });
      Get('shdk/list', null, (data) => {
				let frmShdk = {};
				data.results.forEach((dt) => {
          frmShdk[dt.uuid] = dt.nama
				});
				this.setState({ frmShdk });
			});
      Get("penduduk", null, data => {
        let frmNik = [];
        let frmNik2 = [];
        let tmplistPenduduk = {}
        data.results.data.forEach(dt => {
          frmNik.push({ value: dt.id, label: dt.id + ' (' + dt.nama + ')' });
          frmNik2.push({ value: dt.id, label: dt.id + ' (' + dt.nama + ')' });
          tmplistPenduduk = {
            ...tmplistPenduduk,
            [dt.id]: dt
          }
        });
        this.setState({ frmNik, frmNik2, tmplistPenduduk });

        // For testing
        if (this.props.getListNIK) {
          this.props.getListNIK(frmNik)
        }
      });
      Get("tanda-tangan/list", null, data => {
        data.results.forEach((dt, i) => {
          if (dt.aktif ===  1) {
            let temp = this.state.accButton.map(x => 1);
            temp[i] = 0;
            this.setState({
              accButton: temp,
              accuuid: dt.uuid,
            })
          }
        });
        this.forceUpdate();
        this.setState({ frmTTD: data.results });
      });
    } else {
      this.setState({ redirect: true });
    }
  }

  handleInputChangeNIK = (e, fld) => {
    if (e) {
      if (fld ===  "nik") {
        let nikStat = { value: e, label: e };
        let param = {
          nik: e
        };
        Post("penduduk", null, param, datanik => {
          let frmNik = [];
          datanik.data.results.data.forEach(dt => {
            frmNik.push({ value: dt.id, label: dt.id + ' (' + dt.nama + ')' });
          });
          this.setState({ frmNik, nikStat });
        });
      } else {
        let nik2Stat = { value: e, label: e };
        let param = {
          nik: e
        };
        Post("penduduk", null, param, datanik => {
          let frmNik2 = [];
          datanik.data.results.data.forEach(dt => {
            frmNik2.push({ value: dt.id, label: dt.id });
          });
          this.setState({ frmNik2, nik2Stat });
        });
      }
    }
  };

  getPenduduk = (e, sel) => {
    this.setState({
      status:{
        ...this.state.status,
        btnForm: true,
      },
    })
    this.forceUpdate();
    if (e) {
      this.changeSelectValue(e, sel);
      Get("penduduk/find", e.value, data => {
        // const data_rt = data.results.data_kk.data_rt;
        // const data_rw = data_rt.data_rw;
        // const data_dusun = data_rw.data_dusun;
        // const data_desa = data_dusun.data_keldes;
        // const data_kecamatan = data_desa.data_kecamatan;
        // const data_kabkota = data_kecamatan.data_kabkota;
        
        let alamat = '';
        // if (JENIS_DESA.toLowerCase() ===  'kelurahan') {
        //   alamat =
        //   " RT. " +
        //   data.results.data_kk.data_rt.nama +
        //   "/RW. " +
        //   data.results.data_kk.data_rt.data_rw.nama +
        //   ", " +
        //   data.results.data_kk.data_rt.data_rw.data_keldes.nama +
        //   ", Kec. " +
        //   data.results.data_kk.data_rt.data_rw.data_keldes
        //     .data_kecamatan.nama +
        //   ", " +
        //   data.results.data_kk.data_rt.data_rw.data_keldes
        //     .data_kecamatan.data_kabkota.nama; 
        // } else {
        //   alamat =
        //   " RT. " + 
        //   data.results.data_kk.data_rt.nama +
        //   "/RW. " +
        //   data.results.data_kk.data_rt.data_rw.nama +
        //   ", " + JENIS_DUSUN + " " +
        //   data.results.data_kk.data_rt.data_rw.data_dusun.nama +
        //   ", " +
        //   data.results.data_kk.data_rt.data_rw.data_dusun.data_keldes.nama +
        //   ", Kec. " +
        //   data.results.data_kk.data_rt.data_rw.data_dusun.data_keldes
        //     .data_kecamatan.nama +
        //   ", " +
        //   data.results.data_kk.data_rt.data_rw.data_dusun.data_keldes
        //     .data_kecamatan.data_kabkota.nama; 
        // }
        if (localStorage.getItem('JENIS_DESA').toLowerCase() ===  'kelurahan') {
          alamat =
          " RT. " +
          data.results.data_kk.data_rt.nama +
          "/RW. " +
          data.results.data_kk.data_rt.data_rw.nama +
          ", " +
          data.results.data_kk.data_rt.data_rw.data_keldes.nama +
          ", Kec. " +
          data.results.data_kk.data_rt.data_rw.data_keldes
            .data_kecamatan.nama +
          ", " +
          data.results.data_kk.data_rt.data_rw.data_keldes
            .data_kecamatan.data_kabkota.nama; 
        } else {
          if (data.results.data_kk.id_rt ===  '0') {
            alamat = localStorage.getItem('JENIS_DESA') + " " + data.results.data_keldes.nama + 
            ", Kec. " + data.results.data_keldes.data_kecamatan.nama + 
            ", " + data.results.data_keldes.data_kecamatan.data_kabkota.nama +
            ", " + data.results.data_keldes.data_kecamatan.data_kabkota.data_provinsi.nama; 
          } else {
            alamat =
            " RT. " + 
            data.results.data_kk.data_rt.nama +
            "/RW. " +
            data.results.data_kk.data_rt.data_rw.nama +
            ", " + JENIS_DUSUN + " " +
            data.results.data_kk.data_rt.data_rw.data_dusun.nama +
            ", " + localStorage.getItem('JENIS_DESA') + " " +
            data.results.data_kk.data_rt.data_rw.data_dusun.data_keldes.nama +
            ", Kec. " +
            data.results.data_kk.data_rt.data_rw.data_dusun.data_keldes
              .data_kecamatan.nama +
            ", " +
            data.results.data_kk.data_rt.data_rw.data_dusun.data_keldes
              .data_kecamatan.data_kabkota.nama; 
          }
        }

        if (sel ===  "nik2") {
          this.setState({
            dt:{
              ...this.state.dt,
              nama2: data.results.nama,
              tanggal_lahir2: new Date(
                data.results.tanggal_lahir
              ).toLocaleDateString("id-ID"),
              tempat_lahir2: data.results.tempat_lahir,
              jenis_kelamin2: data.results.jk,
              status_perkawinan2: data.results.status_perkawinan,
              agama2: data.results.data_agama.nama,
              pekerjaan2: data.results.data_pekerjaan.nama,
              kewarganegaraan2: "Indonesia",
              alamat2: alamat,
            },
            status:{
              ...this.state.status,
              dataPenduduk2: "block",
            },
            tanggal_lahir2: data.results.tanggal_lahir,
          })
        } else {
          if (sel ===  "nik3") {
            aw.nik = e.value;
            aw.nama = data.results.nama;
            aw.jenis_kelamin = data.results.jenis_kelamin;
            aw.tanggal_lahir = data.results.tanggal_lahir;
            aw.tempat_lahir = data.results.tempat_lahir;
            aw.pekerjaan = data.results.data_pekerjaan.nama;
          } else {
            Get("catatan-penduduk/nik", data.results.id, dpddk => {
              let pctt = 0;
              let catatan = "";
              if (dpddk.results.data) {
                dpddk.results.data.forEach(dtp => {
                  if (dtp.status ===  0 && dtp.penalti ===  1) {
                    pctt = 1;
                    catatan = dtp.catatan;
                  }
                });
              }
              if (pctt ===  0) {
                Get("penduduk/kk/"+data.results.id_kk, null, dtkk => {
                  // let frmNik = [];
                  // let frmNik2 = [];
                  let frmNik3 = [];
                  dtkk.results.forEach(dt => {
                    // frmNik.push({ value: dt.id, label: dt.id });
                    // frmNik2.push({ value: dt.id, label: dt.id });
                    frmNik3.push({ value: dt.id, label: dt.id + ' (' + dt.nama + ')' });
                  });

                  // For testing
                  if (this.props.getListNIK3) {
                    this.props.getListNIK3(frmNik3)
                  }

                  this.setState({
                    dt:{
                      ...this.state.dt,
                      kk: data.results.id_kk,
                      nama: data.results.nama,
                      tanggal_lahir: new Date(
                        data.results.tanggal_lahir
                      ).toLocaleDateString("id-ID"),
                      tempat_lahir: data.results.tempat_lahir,
                      jenis_kelamin: data.results.jk,
                      status_perkawinan: data.results.status_perkawinan,
                      agama: data.results.data_agama.nama,
                      pekerjaan: data.results.data_pekerjaan.nama,
                      pendidikan_terakhir: data.results.data_pendidikan_terakhir.nama,
                      kewarganegaraan: "Indonesia",
                      alamat: alamat,
                    },
                    status:{
                      ...this.state.status,
                      btnForm: false,
                      dataPenduduk: "block",
                    },
                    tanggal_lahir: data.results.tanggal_lahir,
                    frmNik3: frmNik3,
                  })
                  this.forceUpdate();
                  // this.setState({ frmNik3 });
                });
              } else {
                this.setState({
                  dt:{
                    ...this.state.dt,
                    nama: "",
                    tanggal_lahir: "",
                    tempat_lahir: "",
                    agama: "",
                    pekerjaan: "",
                    pendidikan_terakhir: "",
                    kewarganegaraan: "",
                    alamat: "",
                    jenis_kelamin: "",
                    status_perkawinan: "",
                  },
                  status:{
                    ...this.state.status,
                    dataPenduduk: "none",
                    btnForm: true,
                  },
                  nikStat: null,
                })
                // this.state.frmNik = [];
                this.forceUpdate();
                this.setState({
                  show: true,
                  basicType: "danger",
                  basicTitle: "Peringatan Catatan Warga",
                  pesanAlert:
                    "Warga ini masih memiliki catatan yang belum diselesaikan sebagai berikut. \r" +
                    catatan
                });
              }
              
              // For testing
              if (this.props.selectOnChange) {
                this.props.selectOnChange(this.state.dt)
              }
              if (this.props.selectOnChange3) {
                this.props.selectOnChange3(this.state.dt)
              }
            });
          }
        }
        this.forceUpdate();
      });
    } else {
      if (sel ===  "nik2") {
        this.setState({
          dt:{
            ...this.state.dt,
            nama2: "",
            tanggal_lahir2: "",
            tempat_lahir2: "",
            agama2: "",
            pekerjaan2: "",
            kewarganegaraan2: "",
            alamat2: "",
            jenis_kelamin2: "",
            status_perkawinan2: "",
            tempat_meninggal2: "",
            sebab_meninggal2: "",
          },
          status:{
            ...this.state.status,
            dataPenduduk2: "none",
          },
          nik2Stat: null,
        })
      } else {
        this.setState({
          dt:{
            ...this.state.dt,
            nama: "",
            tanggal_lahir: "",
            tempat_lahir: "",
            agama: "",
            pekerjaan: "",
            pendidikan_terakhir: "",
            kewarganegaraan: "",
            alamat: "",
            jenis_kelamin: "",
            status_perkawinan: "",
          },
          status:{
            ...this.state.status,
            dataPenduduk: "none",
          },
          nikStat: null,
        })
      }
      this.forceUpdate();
    }
  };

  changeInputValue = (e, sel) => {
    switch (sel) {
      case "shdk":
        aw.shdk = e.target.value;
        this.forceUpdate();
        break;
      default:
        // no default
        break;
    }
  };

  changeSelectValue = (e, sel) => {
    if (e) {
      switch (sel) {
        case "jam":
          this.setState({ 
            jamStat: e, 
            dt:{
              ...this.state.dt,
              jam: e.value,
            },
          });
          break;
        case "pekerjaan":
          this.setState({ 
            pkrStat: e, 
            dt:{
              ...this.state.dt,
              pekerjaan: e.label,
            },
          });
          break;
        case "agama":
          this.setState({ 
            agmStat: e, 
            dt:{
              ...this.state.dt,
              agama: e.label,
            },
          });
          break;
        case "nik":
          this.setState({ 
            nikStat: e, 
            dt:{
              ...this.state.dt,
              nik: e.value,
            },
          });
          break;
        case "nik2":
          this.setState({ 
            nik2Stat: e, 
            dt:{
              ...this.state.dt,
              nik2: e.value,
            },
          });
          break;
        case "nik3":
          this.setState({ 
            nik3Stat: e, 
            dt:{
              ...this.state.dt,
              nik3: e.value,
            },
          });
          break;
        case 'shdk_aw':
          this.setState({ shdk_aw: e });
          
          // For testing
          if (this.props.selectOnChangeShdk) {
            this.props.selectOnChangeShdk(e.value)
          }
          break;
        default:
          // no default
          break;
      }
    } else {
      switch (sel) {
        case "jam":
          this.setState({ 
            jamStat: e, 
            dt:{
              ...this.state.dt,
              jam: 0,
            },
          });
          break;
        case "pekerjaan":
          this.setState({ 
            pkrStat: e, 
            dt:{
              ...this.state.dt,
              pekerjaan: "",
            },
          });
          break;
        case "agama":
          this.setState({ 
            agmStat: e, 
            dt:{
              ...this.state.dt,
              agama: "",
            },
          });
          break;
        case "nik":
          this.setState({ 
            nikStat: e, 
            dt:{
              ...this.state.dt,
              nik: 0,
            },
          });
          break;
        case "nik2":
          this.setState({ 
            nik2Stat: e, 
            dt:{
              ...this.state.dt,
              nik2: 0,
            },
          });
          break;
        case "nik3":
          this.setState({ 
            nik3Stat: e, 
            dt:{
              ...this.state.dt,
              nik3: 0,
            },
          });
          break;
        case "shdk_aw":
          this.setState({ shdk_aw: null });
          break;
        default:
          // no default
          break;
      }
    }

    this.forceUpdate();
  };

  tambahAw = e => {
    if (this.state.nik3Stat !==  null && this.state.shdk_aw) {
      detail = this.state.detail;
      Get("penduduk/find", this.state.nik3Stat.value, data => {
        if (data.results) {
          detail.push({
            nik: this.state.nik3Stat.value,
            nama: data.results.nama,
            jenis_kelamin: data.results.jk,
            tanggal_lahir: data.results.tanggal_lahir,
            tempat_lahir: data.results.tempat_lahir,
            pekerjaan: data.results.data_pekerjaan.nama,
            pendidikan: data.results.data_pendidikan_terakhir.nama,
            shdk: this.state.shdk_aw.value,
            keterangan: "",
          });
          this.setState({ detail, nik3Stat: null, shdk_aw: null });
          aw.shdk = "";
          document.getElementById("shdk").value = "";

          
          // For testing
          if (this.props.getDataKeluarga) {
            this.props.getDataKeluarga(detail)
          }
        }
      });
    } else {
      this.setState({
        show: true,
        basicType: "info",
        basicTitle: "Surat Keterangan Tidak Mampu",
        pesanAlert: "Pilih NIK dan hubungan keluarga terlebih dahulu"
      });
    }
  };
  // cek redirect jiksa state kosong
  renderRedirect = () => {
    if (this.state.redirect) {
      return <Redirect to="/" />;
    }
  };

  //change select
  changeAcc = (e, sel) => {
    if (e) {
      switch (sel) {
        case "status-acc":
          this.setState({
            accStat: e,
          })
          break;
        default:
          // no default
          break;
      }
      if (e.value ===  "Disetujui") {
        this.setState({
          tableAcc: "",
          btnFormAcc: true,
        })
        if (this.state.accButton.length > 0) {
          this.setState({
            btnFormAcc: false,
          })
        }
      } else {
        this.setState({
          tableAcc: "none",
          btnFormAcc: false,
        })
      }
    } else {
      switch (sel) {
        case "status-acc":
          this.setState({
            accStat: e,
          })
          break;
        default:
          // no default
          break;
      }
      this.setState({
        tableAcc: "none",
        btnFormAcc: true,
      })
    }
    this.setState({
      status:{
        ...this.state.status,
        select: false,
      },
    })
    this.forceUpdate();
  };

  simpanAcc = e => {
    e.preventDefault();
    this.setState({
      btnFormAcc: true,
    })

    let add = {
      uuid: this.state.accuuid,
      tanggal_surat: new Date(this.state.tanggal_surat)
        .toISOString()
        .slice(0, 10)
    };
    Post(
      "surat-keterangan/tidak-mampu/persetujuan/Selesai/" +
        this.state.idaccSurat,
      null,
      add,
      res => {
        if (res.status === 201) {
          this.setState({
            formAcc: false,
            show: true,
            basicType: "success",
            basicTitle: "Menyetujui Surat",
            pesanAlert: "Berhasil update status"
          });
        } else {
          this.setState({
            btnFormAcc: false,
            show: true,
            basicType: "warning",
            basicTitle: "Menyetujui Surat",
            pesanAlert: "Gagal update status"
          });
        }
        this.componentDidMount();
      }
    );

    this.tutupForm();
  };

  pilih = (uuid, id) => {
    let temp = this.state.accButton.map(x => 1);
    temp[id] = 0;
    this.setState({
      accButton: temp,
      accuuid: uuid,
    })
    if (this.state.accStat) {
      this.setState({
        btnFormAcc: false,
      })
    }
    this.forceUpdate();
  };

  render() {

    //console.log("Data Tidak Mampu")
    //console.log("====================")
    // var size = Math.ceil(
    //   this.state.pagination.total / this.state.pagination.per_page
    // );
    // var size = this.state.pagination.total;
    // var from = this.state.pagination.from;
    // var page = this.state.pagination.current;
    // var to = this.state.pagination.to;
    // var total = this.state.pagination.total;
    var data = this.state.data;

    let no = 0;

    // const tidak_mampu = this.state.detail.map((dt, i) => {
    //   no++;
    //   let jk = "L";
    //   if (dt.jenis_kelamin ===  "Perempuan") {
    //     jk = "P";
    //   }
    //   return (
    //     <tr key={i}>
    //       <td>{no}</td>
    //       <td>{dt.nama}</td>
    //       <td>{jk}</td>
    //       <td>
    //         {dt.tempat_lahir}, {Tanggal(dt.tanggal_lahir)}
    //       </td>
    //       <td>{dt.pekerjaan}</td>
    //       <td>{dt.pendidikan}</td>
    //       <td>{dt.shdk}</td>
    //       <td>
    //         <Button
    //           size="xs"
    //           onClick={() => this.hapus(i)}
    //           color="danger"
    //           className="btn-icon"
    //         >
    //           <i className="fa fa-trash"></i>
    //         </Button>
    //       </td>
    //     </tr>
    //   );
    // });

    // const { SearchBar } = Search;
    const columns = [
      {
          dataField: "no",
          text: "No",
          isDummyField: true,
          csvExport: false,
          headerAlign: 'center',
				  align: 'center',
          formatter: (key, obj, index) =>{          
              let current_pagenum = this.state.pagination.current_page;
              let total_records_per_page = this.state.pagination.per_page;
              let row_index = (index+1);
              let serial_num = ((total_records_per_page*(current_pagenum-1))+row_index);
              return serial_num; 
          }
      },
      {
        dataField: "tanggal_surat",
        headerAlign: 'center',
				align: 'center',
        text: "Tanggal",
        formatter: (cell, obj) => {
          let plainTime = '-'
					if (obj.created_at) {
						let date = new Date(obj.created_at)
						date = date.toLocaleString('id-ID')
						
						const datetime = date.split(' ')
						
	
						date = datetime[0]
						let time = datetime[1]
	
						const splitDate = date.split('/')
						time = time.replaceAll('.', ':')
	
						// console.log(date)
						const list_bulan = [
							'Januari',
							'Februari',
							'Maret',
							'April',
							'Mei',
							'Juni',
							'Juli',
							'Agustus',
							'September',
							'Oktober',
							'November',
							'Desember'
						];

						plainTime = `${splitDate[0]} ${list_bulan[parseInt(splitDate[1]) - 1]} ${splitDate[2]}  ${time}`;
					}

					return plainTime
        },
        isDummyField: true,

        sort: true
      },
      {
        dataField: "kode_surat",
        headerAlign: 'center',
				align: 'center',
        text: "Kode Pengajuan",
        formatter: (cell, obj) => {
          return obj.kode_surat === "" || obj.kode_surat === null ? "-" : obj.kode_surat;
        },
        sort: true
      },
      {
        dataField: "nomor",
        headerAlign: 'center',
				align: 'center',
        text: "Nomor surat",
        formatter: (cell, obj) => {
          return obj.nomor === "" ? "-" : obj.nomor;
        },
        sort: true
      },
      {
        dataField: "nik",
        headerAlign: 'center',
				align: 'center',
        text: "NIK",
        sort: true
      },
      {
        dataField: "nama_pemohon",
        headerAlign: 'center',
				align: 'center',
        text: "Nama",
        sort: true
      },
      {
        dataField: "status",
        headerAlign: 'center',
				align: 'center',
        text: "Status",
        isDummyField: true,
        formatter: (cell, obj) => {
          let status = "-";
          obj.data_status.forEach(dt => {
            status = dt.status;
          });
          
          if(status === 'Selesai Mobile'){
            status = "Disetujui";
          }

          return status;
        },
        sort: true
      },
      {
        dataField: "aksi",
        headerAlign: 'center',
				align: 'center',
        text: "Aksi",
        isDummyField: true,
        csvExport: false,
        formatter: this.tombolAksi
      }
    ];

    // const defaultSorted = [
    //   {
    //     dataField: "nama",
    //     order: "asc"
    //   }
    // ];

    // const pageButtonRenderer = ({
    //   page,
    //   active,
    //   disable,
    //   title,
    //   onPageChange
    // }) => {
    //   const handleClick = e => {
    //     e.preventDefault();
    //     this.fetch({ where: [], page: page });
    //   };
    //   var classname = "";
    //   classname = "btn btn-primary-custom";
    //   return (
    //     <li className="page-item pl-1" key={page}>
    //       <a href="#" onClick={handleClick} className={classname}>
    //         {page}
    //       </a>
    //     </li>
    //   );
    // };

    // const options = {
    //   alwaysShowAllBtns: true,
    //   pageButtonRenderer,
    //   // custom: true,
    //   paginationTotalRenderer: () => (
    //     <span className="react-bootstrap-table-pagination-total">
    //       Showing {from} to {to} of {total} Results
    //     </span>
    //   ),
    //   paginationSize: size,
    //   totalSize: total
    // };
    no = 0;

    const tableTTD = this.state.frmTTD.map((dt, i) => {
      no++;
      return (
        <tr key={i}>
          <td>{no}</td>
          <td>{dt.jabatan}</td>
          <td>{dt.jabatan_pengganti ? dt.jabatan_pengganti : "-"}</td>
          <td>{dt.nama}</td>
          <td>{dt.nip ? dt.nip : "-"}</td>
          <td>{dt.status ? dt.status : "-"}</td>
          <td>
            <Button
              size="xs"
              onClick={() => this.pilih(dt.uuid, i)}
              color={
                this.state.accButton.length > 0
                  ? this.state.accButton[i] ===  0
                    ? "default"
                    : "danger"
                  : "danger"
              }
              className="btn-icon"
            >
              {this.state.accButton.length > 0
                ? this.state.accButton[i] ===  0
                  ? "Dipilih"
                  : "Pilih"
                : "Pilih"}
            </Button>
          </td>
        </tr>
      );
    });

    return (
      <div data-testid="page-surat keterangan tidak mampu">
        {this.renderRedirect()}
        {/* <Breadcrumb title="Data Surat Keterangan Tidak Mampu" parent="Admin" /> */}
        <SweetAlert
          show={this.state.show}
          type={this.state.basicType}
          title={this.state.basicTitle}
          confirmBtnBsStyle="success"
          cancelBtnBsStyle="info"
          onCancel={this.closeAlert}
          showConfirm={false}
        >
          {this.state.pesanAlert}
          {this.state.successAlert ? (
            <div>
              <br />
              <Button
                color="success"
                onClick={() => {
                  this.closeAlert();
                  this.tambahData();
                }}
              >
                Tambah Data
              </Button>{" "}
              <Button
                color="info"
                className="btn btn-secondary-custom"
                // onClick={() => {
                //   this.closeAlert();
                // }}
              >
                <Link
                  data-testid="btn-eksekusi_surat"
                  onClick={() => {
                    // For testing
                    if (this.props.clickEksekusiSurat) {
                      this.props.clickEksekusiSurat()
                    }
                  }}
                  to={{
                    pathname: process.env.PUBLIC_URL + "/admin/disposisi",
                    tabProps: "2"
                  }}
                >
                  <span style={{ color: "white" }}>Eksekusi Surat</span>
                </Link>
              </Button>
            </div>
          ) : (
            ""
          )}
        </SweetAlert>

        {this.state.alert}

        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12">
              <div className="card mb-0">
                <div className="card-header">
                  <div className="row">
                    <div className="col-sm-6">
                      <input
                        type="text"
                        className="form-control"
                        id="cariTable"
                        placeholder="Cari berdasarkan kode pengajuan atau nik pemohon atau nomor surat"
                        onKeyPress={this.cariData}
                      />
                    </div>
                    <div className="col-sm-6 text-right">
                      <Button
                        data-testid="tblCreateSuratKeteranganTidakMampu"
                        size="sm"
                        color="success"
                        // className="btn-square"
                        onClick={() => {
                          this.tambahData()
                        }}
                      >
                        Tambah Data
                      </Button>
                    </div>
                  </div>
                </div>
                <div className="card-body datatable-react">
                  {this.state.loading ? (
                    <div className="row">
                      <div className="col-sm-12" align="center">
                        <img 
                        alt="loading"
                        src={require("../assets/images/tes-loading.gif")} 
                        style={{
                          borderRadius: "10px",
                          width: '100px'
                        }}/> 
                      </div>
                    </div>
                  ) : (
                    <>
                      {data.length > 0 ? (
                        <>
                          <BootstrapTable keyField="id" data={data} columns={columns} />
                          <div className="pull-right text-white">
                            {this.state.awal}
                            {this.state.sebelum}
                            {this.state.hal.map(dt => {
                              return dt;
                            })}
                            {this.state.setelah}
                            {this.state.akhir}
                          </div>
                        </>
                      ) : (
                        <div className="row">
                          <div className="col-md-12">
                            <h6 className="text-center mb-2 mt-2">Data tidak ditemukan</h6>
                          </div>
                        </div>
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <br />
        {/* Loading preview */}
        <SweetAlert
					show={this.state.loadingPreview}
					showCancel = {false}
					showConfirm={false}
				>
					<div align="center">
						<h5 className="modal-title" style={{ textAlign: "center", color: 'black' }}>Sedang memuat data...</h5>
						<br/>
						<img 
							alt="loading"
							src={require("../assets/images/tes-loading.gif")} 
							style={{
								// width: "100%",
								borderRadius: "10px",
								width: '150px'
							}}
						/> 
						<br/><br/>
					</div>
				</SweetAlert>

        <ModalSuratTidakMampu
          data={this.state.dt}
          isOpen={this.state.status.form}
          propsData={this.props}
          kiosk={false}
          optionData={{
            frmNik: this.state.frmNik,
            frmNik2: this.state.frmNik2,
            frmNik3: this.state.frmNik3,
            tmplistPenduduk: this.state.tmplistPenduduk,
            tmplistPenduduk3: this.state.tmplistPenduduk3,
            frmShdk: this.state.frmShdk,
            nikStat: this.state.nikStat,
            nik2Stat: this.state.nik2Stat,
            status: this.state.status,
            formOpsional: this.state.formOpsional,
            opsionalStat: this.state.opsionalStat,
            dataAnggotaKeluarga: this.state.status.dataAnggotaKeluarga,
            dataOrangTua: this.state.status.dataOrangTua,
            frmDataOrangTua: this.state.status.frmDataOrangTua,
            frmDetailDataOrangTua: this.state.status.frmDetailDataOrangTua,
            frmKeteranganTambahan: this.state.status.frmKeteranganTambahan,
          }}
          setAlert={(e) => {
            this.setState(e)
          }}
          setStatusRefresh={(e) => {
            if (e) {
              this.fetch({ page: null, where: [] });
            }
          }}
          setIsOpen={(e) => {
            if (!e) {
              this.setState({ dt: null })
            }
            this.setState({
              status: {
                ...this.state.status,
                form: e
              }
            })
          }}
        />

        
				{/* Modal Preview Draft Surat */}
				<Modal
					classNames={{ overlay: 'custom-map-modal' }}
					open={this.state.status.frmPreviewDraft}
					onClose={() => {
						// this.setState({
						// 	status:{
						// 		...this.state.status,
						// 		modalKonfirmasi: true,
						// 		frmPreviewDraft: false,
						// 	}
						// })
					}}
					styles={{ 
						modal: {
							width: '100%',
							height: '100%',
							maxHeight: 'unset',
							maxWidth: 'unset',
						  }
					}}
					closeOnEsc={false}
					closeOnOverlayClick={false}
				>
					<div
						className="modal-body"
						style={{
							display: 'flex',
							justifyContent: 'center',
							flexDirection: 'column',
							height: '90%',
							alignItems: 'center'
						}}
					>
							<center>
								<span><h4><b>Berikut adalah draft surat yang telah anda ajukan,<br/> silahkan cek kelengkapan data anda sebelum melanjutkan!</b></h4></span><br/>
							</center>

							<Iframe 
								id="myFrame" 
								src={
									API_URL +
									// 'cetak-surat/' +
									this.state.get_jenis_surat +
									// '/' +
									this.state.get_data_surat.uuid_surat +
									'?show=Ya&status_preview=ya#toolbar=0'
								}
								// styles={
								// 	{display: 'none'}
								// }
								onLoad={(e) => {
									this.setState({
										loadingPreview: false
									})
								}}
								width="100%"
								height="100%"
								className="myClassname"
								display={this.state.loadingPreview ? "none" : "block"}
								position="relative"
							/>
						{/* </div> */}
					</div>
					<div
						className="modal-footer"
						style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
					>
						<button
							onClick={() => {
                this.setState({
									status:{
                    ...this.state.status,
                    frmPreviewDraft: false,
                  },
								})
								this.ubahData(this.state.get_data_surat.uuid_surat)
							}}
							className="btn btn-warning"
						>
							Ubah Data Pengajuan
						</button>
						<button
							onClick={() => {
                this.setState({
                  status:{
                    ...this.state.status,
                    frmPreviewDraft: false,
                  },
                  showBio: false,
                  show: true,
                  basicType: "success",
                  basicTitle: "Data Surat Keterangan Tidak Mampu",
                  pesanAlert: "Berhasil "+ this.state.status.jenis_form +" Data",
                  successAlert: true
                });
							}}
							className="btn btn-success"
						>
							Lanjutkan Pengajuan
						</button>
					</div>
				</Modal>
				{/* End Modal Preview Draft Surat */}


        {/* Modal Lama */}
        {/* <Modal
          open={this.state.status.form}
          onClose={this.tutupForm}
          closeOnEsc={false}
          closeOnOverlayClick={false}
        >
          <Form  
            data-testid="form-create" 
            className="theme-form" 
            onSubmit={this.simpan}
          >
            <div className="modal-header">
              <h5 className="modal-title">{this.state.judul}</h5>
            </div>
            <div className="modal-body">
              <p>
                Data identitas akan terisi secara otomatis saat NIK dipilih.
                Jika ada ketidak sesuaian data, silakan ubah di data master
                penduduk.
              </p>
              <input
                className="form-control"
                id="uuid"
                type="hidden"
                placeholder=""
                defaultValue={this.state.dt.uuid}
              />
              <FormGroup className="row">
                <Label
                  className="col-sm-3 col-form-label"
                  htmlFor="nik"
                >
                  NIK
                </Label>
                <Col sm="9">
                  <div data-testid="selectNIK">
                    <Select
                      inputId="nik"
                      name="nik"
                      classNamePrefix="select"
                      onChange={e => {
                        this.getPenduduk(e, "nik");
                      }}
                      defaultValue={this.state.nikStat}
                      value={this.state.nikStat}
                      options={this.state.frmNik}
                      placeholder="Pilih NIK"
                      onInputChange={e => this.handleInputChangeNIK(e, "nik")}
                      isClearable
                    />
                  </div>
                </Col>
              </FormGroup>
              <div style={{ display: this.state.status.dataPenduduk }}>
                <FormGroup className="row">
                  <Label
                    className="col-sm-3 col-form-label"
                    htmlFor="inputEmail3"
                  >
                    Nama Pemohon
                  </Label>
                  <Col sm="9">
                    <input
                      className="form-control"
                      id="nama"
                      type="text"
                      placeholder="Nama Pemohon"
                      value={this.state.dt.nama}
                      readOnly
                      style={{ backgroundColor:"#c9d1d8" }}
                      disabled
                    />
                  </Col>
                </FormGroup>
                <FormGroup className="row">
                  <Label
                    className="col-sm-3 col-form-label"
                    htmlFor="inputEmail3"
                  >
                    Tempat Lahir
                  </Label>
                  <Col sm="9">
                    <input
                      className="form-control"
                      id="tempat_lahir"
                      type="text"
                      placeholder="Tempat Lahir"
                      value={this.state.dt.tempat_lahir}
                      readOnly
                      style={{ backgroundColor:"#c9d1d8" }}
                      disabled
                    />
                  </Col>
                </FormGroup>
                <FormGroup className="row">
                  <Label
                    className="col-sm-3 col-form-label"
                    htmlFor="inputEmail3"
                  >
                    Tanggal Lahir
                  </Label>
                  <Col sm="9">
                    <input
                      className="form-control"
                      id="tanggal_lahir"
                      type="text"
                      placeholder="Tanggal Lahir"
                      value={this.state.dt.tanggal_lahir}
                      readOnly
                      style={{ backgroundColor:"#c9d1d8" }}
                      disabled
                    />
                  </Col>
                </FormGroup>
              </div>
              <div style={{ display: "none" }}>
                <FormGroup className="row">
                  <Label
                    className="col-sm-3 col-form-label"
                    htmlFor="inputEmail3"
                  >
                    KK
                  </Label>
                  <Col sm="9">
                    <input
                      className="form-control"
                      id="kk"
                      type="text"
                      placeholder="Nomor KK"
                      value={this.state.dt.kk}
                      readOnly
                    />
                  </Col>
                </FormGroup>
                <FormGroup className="row">
                  <Label
                    className="col-sm-3 col-form-label"
                    htmlFor="inputEmail3"
                  >
                    Jenis Kelamin
                  </Label>
                  <Col sm="9">
                    <input
                      className="form-control"
                      id="jenis_kelamin"
                      type="text"
                      placeholder="Jenis Kelamin"
                      value={this.state.dt.jenis_kelamin}
                      readOnly
                    />
                  </Col>
                </FormGroup>
                <FormGroup className="row">
                  <Label
                    className="col-sm-3 col-form-label"
                    htmlFor="inputEmail3"
                  >
                    Pekerjaan
                  </Label>
                  <Col sm="9">
                    <input
                      className="form-control"
                      id="pekerjaan"
                      type="text"
                      placeholder="Pekerjaan"
                      value={this.state.dt.pekerjaan}
                      readOnly
                    />
                  </Col>
                </FormGroup>
                <FormGroup className="row">
                  <Label
                    className="col-sm-3 col-form-label"
                    htmlFor="inputEmail3"
                  >
                    Pendidikan Terakhir
                  </Label>
                  <Col sm="9">
                    <input
                      className="form-control"
                      id="pendidikan_terakhir"
                      type="text"
                      placeholder="Pendidikan Terakhir"
                      value={this.state.dt.pendidikan_terakhir}
                      readOnly
                    />
                  </Col>
                </FormGroup>
                <FormGroup className="row">
                  <Label
                    className="col-sm-3 col-form-label"
                    htmlFor="inputEmail3"
                  >
                    Kewarganegaraan
                  </Label>
                  <Col sm="9">
                    <input
                      className="form-control"
                      id="kewarganegaraan"
                      type="text"
                      placeholder="Pekerjaan"
                      value={this.state.dt.kewarganegaraan}
                      readOnly
                    />
                  </Col>
                </FormGroup>
                <FormGroup className="row">
                  <Label
                    className="col-sm-3 col-form-label"
                    htmlFor="inputEmail3"
                  >
                    Status Perkawinan
                  </Label>
                  <Col sm="9">
                    <input
                      className="form-control"
                      id="status_perkawinan"
                      type="text"
                      placeholder="Status Perkawinan"
                      value={this.state.dt.status_perkawinan}
                      readOnly
                    />
                  </Col>
                </FormGroup>
                <FormGroup className="row">
                  <Label
                    className="col-sm-3 col-form-label"
                    htmlFor="inputEmail3"
                  >
                    Agama
                  </Label>
                  <Col sm="9">
                    <input
                      className="form-control"
                      id="agama"
                      type="text"
                      placeholder="Agama"
                      value={this.state.dt.agama}
                      readOnly
                    />
                  </Col>
                </FormGroup>
                <FormGroup className="row">
                  <Label
                    className="col-sm-3 col-form-label"
                    htmlFor="inputEmail3"
                  >
                    Alamat
                  </Label>
                  <Col sm="9">
                    <input
                      className="form-control"
                      id="alamat"
                      type="text"
                      placeholder="Alamat"
                      value={this.state.dt.alamat}
                      readOnly
                    />
                  </Col>
                </FormGroup>
              </div>

              
              <FormGroup className="row">
                <Label className="col-sm-3 col-form-label" htmlFor="inputEmail3">
                  Keperluan Untuk
                </Label>
                <Col sm="9">
                  <input
                    data-testid="tujuan pembuatan"
                    name="tujuan_pembuatan"
                    className="form-control"
                    id="tujuan_pembuatan"
                    type="text"
                    placeholder="Keperluan Untuk"
                    defaultValue={this.state.dt.tujuan_pembuatan}
                    required
                  />
                </Col>
              </FormGroup>

              <FormGroup className="row">
                <Label className="col-sm-12 col-form-label">
                  Daftar Keluarga Yang Ikut
                </Label>
                <Col sm="5">
                  <div data-testid="selectNIK3">
                    <Select
                      inputId="nik3"
                      classNamePrefix="select"
                      onChange={e => {
                        this.changeSelectValue(e, "nik3");
                      }}
                      defaultValue={this.state.nik3Stat}
                      value={this.state.nik3Stat}
                      name="NIK3"
                      options={this.state.frmNik3}
                      placeholder="Pilih NIK Tidak Mampu"
                      // onInputChange={e => this.handleInputChangeNIK(e, "nik3")}
                      isClearable
                    />
                  </div>
                </Col>
                <Col sm="4">
                  <div data-testid="selectShdk">
                    <Select
                      inputId="shdk_aw"
                      classNamePrefix="select"
                      onChange={(e) => {
                        this.changeSelectValue(e, 'shdk_aw');
                      }}
                      value={this.state.shdk_aw}
                      id="shdk"
                      options={[
                        { value: 'Suami', label: 'Suami' },
                        { value: 'Isteri', label: 'Isteri' },
                        { value: 'Orang Tua', label: 'Orang Tua' },
                        { value: 'Anak', label: 'Anak' },
                        { value: 'Kakak', label: 'Kakak' },
                        { value: 'Adik', label: 'Adik' },
                        { value: 'Mertua', label: 'Mertua' },
                        { value: 'Menantu', label: 'Menantu' },
                        { value: 'Cucu', label: 'Cucu' },
                        { value: 'Pembantu', label: 'Pembantu' },
                        { value: 'Famili Lain', label: 'Famili Lain' }
                      ]}
                      placeholder="Hubungan Keluarga"
                    />
                  </div>
                </Col>
                <Col sm="3">
                  <button
                    data-testid="btnTambahKeluarga"
                    type="button"
                    className="btn btn-success"
                    onClick={this.tambahAw}
                  >
                    Tambah
                  </button>
                </Col>
                <Col sm="12">
                  <table className="table table-bordered table-stripes table-hovered">
                    <thead>
                      <tr>
                        <th>No</th>
                        <th>Nama</th>
                        <th>JK</th>
                        <th>Tempat/Tanggal Lahir</th>
                        <th>Pekerjaan</th>
                        <th>Pendidikan</th>
                        <th>Hubungan Keluarga</th>
                        <th>
                          <i className="fa fa-trash"></i>
                        </th>
                      </tr>
                    </thead>
                    <tbody>{tidak_mampu}</tbody>
                  </table>
                </Col>
              </FormGroup>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-warning"
                onClick={this.tutupForm}
              >
                Tutup
              </button>
              <button
                data-testid="btnSubmitCreate"
                type="submit"
                className="btn btn-primary-custom"
                disabled={this.state.status.btnForm}
              >
                Simpan
              </button>
            </div>
          </Form>
        </Modal> */}
        {/* End Modal Lama */}

        <Modal
          open={this.state.formAcc}
          onClose={this.tutupForm}
          styles={{ modal: { width: "80%" } }}
          closeOnEsc={false}
          closeOnOverlayClick={false}
        >
          <Form className="theme-form" onSubmit={this.simpanAcc}>
            <div className="modal-header">
              <h5 className="modal-title">Konfirmasi Surat</h5>
            </div>
            <div className="modal-body">
              <FormGroup className="row">
                <Label
                  className="col-sm-3 col-form-label"
                  htmlFor="inputEmail3"
                >
                  Tanggal Surat
                </Label>
                <Col sm="9">
                  {/* <Datepicker
                    id="tanggal_surat"
                    todayButton={"Today"}
                    dateFormat="dd/MM/yyyy"
                    selected={this.state.tanggal_surat}
                    onChange={e => this.gantiTgl(e, "tanggal_surat")}
                    className="form-control"
                  /> */}
                </Col>
              </FormGroup>

              <Col sm="12">
                <table className="table table-bordered table-stripes table-hovered">
                  <thead>
                    <tr>
                      <th>No</th>
                      <th>Jabatan</th>
                      <th>Jabatan Pengganti</th>
                      <th>Nama</th>
                      <th>NIP</th>
                      <th>Status</th>
                      <th>
                        <i className="fa fa-check"></i>
                      </th>
                    </tr>
                  </thead>
                  <tbody>{tableTTD}</tbody>
                </table>
              </Col>
            </div>
            <div className="modal-footer">
              <button type="submit" className="btn btn-primary-custom">
                Selesai
              </button>
            </div>
          </Form>
        </Modal>
        <Modal
          open={this.state.formDisposisi}
          onClose={this.tutupForm}
          styles={{ modal: { width: "80%" } }}
          closeOnEsc={false}
          closeOnOverlayClick={false}
        >
          <Form className="theme-form">
            <div className="modal-header">
              <h5 className="modal-title">Disposisi Surat</h5>
            </div>
            {/* <div className="modal-body">
              <table className="table table-bordered table-stripes table-hovered">
                <thead>
                  <tr>
                    <th>No</th>
                    <th>Jabatan</th>
                    <th>Level</th>
                    <th>TTD</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.datDisposisi.map((dt, i) => {
                    return (
                      <tr key={i}>
                        <td>{i + 1}</td>
                        <td>{dt.data_jabatan.nama}</td>
                        <td>{dt.level}</td>
                        <td>
                          <button
                            type="button"
                            className="btn btn-info"
                            onClick={() => {
                              this.disposisi(dt.uuid, this.state.idSurat);
                            }}
                            disabled={this.state.status.btnForm}
                          >
                            Disposisi
                          </button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
             */}
            <div className="modal-body">
              <table className="table table-bordered table-stripes table-hovered">
                <thead>
                  <tr>
                    <th>No</th>
                    <th>Status</th>
                    <th>Pejabat</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.riwayatDisposisi.map((dt, i) => {
                    return (
                      <tr key={i}>
                        <td>{i + 1}</td>
                        <td>
                          {dt.status ===  0
                            ? "Menunggu Disposisi"
                            : dt.status ===  1
                            ? "Telah di disposisi"
                            : "Ditolak"}
                        </td>
                        <td>{dt.data_perangkat.data_jabatan.nama}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-warning"
                disabled={this.state.btnFormAcc}
                onClick={this.tutupForm}
              >
                Tutup
              </button>
              <button
                type="submit"
                className="btn btn-success"
                disabled={this.state.btnFormAcc}
              >
                Simpan
              </button>
            </div>
          </Form>
        </Modal>

      </div>
    );
  }
}

export default BasicTable;